import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, change, formValueSelector } from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { FormsConstants } from '../../../state/forms'
import {
  FormButtons,
  validations,
  renderers,
  titleCase,
  lowerCase,
  Slider,
} from '../../../components'
import { TicketService, TokenService } from '../../../services'
import { TicketListPage } from '../TicketListPage'
import {getMultipleLists} from "../../../state/lists";
import {getRights} from "../../../state/rights";
const maxLength10 = validations.maxLength(10)
let CustomerForm = ({
  dispatch,
  handleSubmit,
  pristine,
  reset,
  submitting,
  editMode,
  selectedOrganization,
  token_number,
  customerEmail,
  customerContactNumber,
}) => {
  const { user } = useSelector((state) => state.auth)
  const { rights } = useSelector((state) => state.userRights)
  const { states } = useSelector((state) => state.lists)
  const { country } = useSelector((state) => state.lists)
  const { customer_type } = useSelector((state) => state.lists)
  const { organization } = useSelector((state) => state.machineConfig)
  const [previousTicketsCounts, setPreviousTicketsCounts] = useState(null)
  console.log("organization",organization)
  useEffect(() => {
         !rights && dispatch(getRights(user))
        !(states && country && customer_type) && dispatch(getMultipleLists(['STATES','COUNTRY','CUSTOMER_TYPE']))
    if(editMode){
      return
    }
    organization &&
      dispatch(
        change(
          FormsConstants.formNames.CUSTOMER_FORM,
          'organization',
          organization.url
        )
      )
    organization &&
      dispatch(
        change(
          FormsConstants.formNames.CUSTOMER_FORM,
          'state',
          organization.state
        )
      )
     organization &&
      dispatch(
        change(
          FormsConstants.formNames.CUSTOMER_FORM,
          'city',
          organization.city
        )
      )
     organization &&
      dispatch(
        change(
          FormsConstants.formNames.CUSTOMER_FORM,
          'country',
          organization.country
        )
      )

  }, [])

  const isValidToken = (value) => {
    return !isNaN(value)
  }
  const getTokenInfo = (e) => {
     console.log("selectedOrganization",selectedOrganization)
    const index = rights
      .filter((x) => x.tickets === true)
      .findIndex((emp) => emp.organization === selectedOrganization)
    const selectedRight=   rights.filter((x) => x.tickets === true)[
      index
    ]
    let organization_code = organization.code
    if(selectedRight)
      organization_code = selectedRight.organization_code
    new TokenService().fetch_token_info(organization_code, token_number).then(
      (response) => {
        if (response.url || response.token_number) {
          const tokenInfo = response
          setPreviousTicketsCounts(tokenInfo.previous_tickets_counts)
          if (tokenInfo) {
            Object.keys(tokenInfo).forEach((element) => {
              dispatch(
                change(
                  FormsConstants.formNames.CUSTOMER_FORM,
                  element,
                  tokenInfo[element]
                )
              )
            })
          }
        } else {
          setPreviousTicketsCounts({
            email: 'NA',
            contact_number: 'NA',
          })
        }
      },
      (errors) => {}
    )
  }
  const getPinCodeInfo = (e) => {
    new TicketService().get_pin_code_info(e.target.value).then((res) => {
      dispatch(
        change(FormsConstants.formNames.CUSTOMER_FORM, 'state', res['State'])
      )
      dispatch(
        change(FormsConstants.formNames.CUSTOMER_FORM, 'city', res['District'])
      )
    })
  }

  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        {!editMode && (
          <>
            <ReactBootstrap.Col md={6} xs={12} lg={6}>
              <Field
                component={renderers.renderSelectField2}
                as="select"
                validate={[validations.required]}
                name="organization"
                label="Ship To"
                options={rights.filter(x=>x.is_active && x.tickets).map((opt)=>{
                 return  {
                   "text":`${opt.organization_code}-----${opt.organization_name}`,
                   "value":opt.organization}
                })}
         />
            </ReactBootstrap.Col>
            <ReactBootstrap.Col md={6} xs={12} lg={6}>
              <Field
                name="token_number"
                label="Token Number"
                validate={[validations.required]}
                component={renderers.renderField}
                type="text"
              />

              {token_number && selectedOrganization && (
                <ReactBootstrap.Col className="text-end">
                  <ReactBootstrap.Button
                    variant="link"
                    className="btn text-dark btn-sm"
                    // disabled={!isValidToken(token_number)}
                    type="button"
                    onClick={getTokenInfo}
                  >
                    Get Token Info
                  </ReactBootstrap.Button>
                </ReactBootstrap.Col>
              )}
            </ReactBootstrap.Col>
          </>
        )}
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="first_name"
            label="Customer First Name"
            normalize={titleCase}
            validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            label="Customer Last Name"
            name="last_name"
            normalize={titleCase}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12}>
          <Field
            name="company_name"
            label="Company Name"
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>

        <ReactBootstrap.Col xs={11}>
          <Field
            label="Customer Email"
            name="email"
            normalize={lowerCase}
            validate={[validations.required, validations.email]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col className={"pt-5"}  xs={1}>
          {previousTicketsCounts && previousTicketsCounts.email && (
            <Slider
              title={previousTicketsCounts.email}
              variant="success"

              header={`${previousTicketsCounts.email} Previous Tickets by Email`}
            >
              <TicketListPage
                defaultFilters={{
                  customer: customerEmail,
                }}
              />
            </Slider>
          )}
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={5} xs={11} lg={5}>
          <Field
            label="Customer Contact Number"
            name="contact_number"
            validate={[validations.required, validations.contactNumber,maxLength10]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col className={"pt-5"} md={1} xs={11} lg={1}>
          {previousTicketsCounts && previousTicketsCounts.contact_number && (
            <Slider
              title={previousTicketsCounts.contact_number}
              variant="success"
              header={`${previousTicketsCounts.contact_number} Previous Tickets by Contact Number `}
            >
              <TicketListPage
                defaultFilters={{
                  customer: customerContactNumber,
                }}
              />
            </Slider>
          )}
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            label="Alternative Contact Number"
            name="alternate_contact_number"
            validate={[validations.contactNumberOrEmpty]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>



        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            label="Customer Address Line 1"
            name="address_line_1"
            validate={[validations.required]}
            normalize={titleCase}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            label="Customer Address Line 2"
            name="address_line_2"
            normalize={titleCase}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            label="Customer Address Line 3"
            name="street"
            normalize={titleCase}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="pin_code"
            label="PIN Code"
            onBlur={getPinCodeInfo}
            validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="city"
            label="Customer City"
            normalize={titleCase}
            validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            component={renderers.renderSelectField2}
            as="select"
            validate={[validations.required]}
            name="state"
            label="State"
             options={states && states.map((opt)=>{
                 return  {
                   "text":opt.value,
                   "value":opt.value}
             })}
          >

          </Field>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            validate={[validations.required]}
            name="country"
            label="Country"
          >
            {country &&
              country.map &&
              country.map((c) => {
                return (
                  <option key={c.url} value={c.value}>
                    {c.value}
                  </option>
                )
              })}
          </Field>
        </ReactBootstrap.Col>

        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="customer_type"
            label="Customer Type"
            validate={[validations.required]}
            component={renderers.renderSelectField}
            as="select"
          >
            {customer_type &&
              customer_type.map &&
              customer_type.map((c) => {
                return (
                  <option key={c.url} value={c.value}>
                    {c.value}
                  </option>
                )
              })}
          </Field>
        </ReactBootstrap.Col>
            <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="send_sms_on_primary_phone_via_gsx"
            label="Send SMS via gsx"
            validate={[validations.required]}
            component={renderers.renderSelectField}
            as="select"
          >
              {
               [
      { key: 'key_boolean_list_true', value: true, text: 'Yes' },
      { key: 'key_boolean_list_false', value: false, text: 'No' },
    ].map((sp) => (
                <option key={sp.key} value={sp.value}>
                  {sp.text}
                </option>
              ))}
          </Field>
        </ReactBootstrap.Col>

      </ReactBootstrap.Row>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
CustomerForm = reduxForm({
  form: FormsConstants.formNames.CUSTOMER_FORM,
  initialValues: {
    country: 'India',
  },
})(CustomerForm)

const selector = formValueSelector(FormsConstants.formNames.CUSTOMER_FORM)
CustomerForm = connect((state) => {
  const selectedOrganization = selector(state, 'organization')
  const token_number = selector(state, 'token_number')
  const customerEmail = selector(state, 'email')
  const customerContactNumber = selector(state, 'contact_number')
  return {
    selectedOrganization,
    token_number,
    customerEmail,
    customerContactNumber,
  }
})(CustomerForm)

export default CustomerForm
